import { Expose } from 'class-transformer'
import { DocumentSnapshot } from 'firebase/firestore'
import { _FirebaseDocument } from './Models'

export type MemberRole = 'admin' | 'member'
export type MemberType = 'tenant' | 'project'

export class Member extends _FirebaseDocument {
    @Expose()
    public active: boolean | undefined
    @Expose()
    public uid: string | undefined
    @Expose()
    public email: string | undefined
    @Expose()
    public display_name: string | undefined
    @Expose()
    public type: MemberType | undefined
    @Expose()
    public role: MemberRole | undefined

    collection(): string {
        return 'members'
    }

    static fromFirebase(o: DocumentSnapshot): Member | null {
        const m = _FirebaseDocument._fromFirebase<Member>(Member, o)
        if (!m) return null
        // Fallback: if uid is not set in document, use the document id
        if (!m.uid) (m as Member).uid = o.id
        return m
    }
}


